import React, { FC, memo } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { List, ListItem } from '@ucheba/ui/components/List/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { IBlockWithList } from '../types'
import SC from '../base/BlockWithList.styles'
import ButtonRegEvent from '../../ButtonRegEvent/desktop'

const { Block, Image, TextSC } = SC

const BlockWithList: FC<IBlockWithList> = (props) => {
  const { title, items, doubleColumns, button } = props

  if (doubleColumns) {
    return (
      <Block>
        <Spacing spacing='uxlarge' />

        {title && <Heading h2={title} />}

        {items && items.length > 0 && (
          <Grid>
            <GridCol uxs={12}>
              <List>
                {items
                  .filter((_, key, arr) => Math.ceil(arr.length / 2) >= key + 1)
                  .map((el, key) => (
                    <ListItem
                      key={key}
                      StartIcon={<Image src={el.icon} style={{ marginTop: '-2px' }} />}
                      alignItems='flex-start'
                    >
                      {el.title && (
                        <>
                          <TextSC fontWeight='bold'>{el.title}</TextSC>

                          <Spacing spacing='xxsmall' />
                        </>
                      )}

                      <TextSC>{el.text}</TextSC>
                    </ListItem>
                  ))}
              </List>
            </GridCol>

            <GridCol uxs={12}>
              <List>
                {items
                  .filter((_, key, arr) => Math.ceil(arr.length / 2) < key + 1)
                  .map((item, key) => (
                    <ListItem
                      key={key}
                      StartIcon={<Image src={item.icon} style={{ marginTop: '-2px' }} />}
                      alignItems='flex-start'
                    >
                      {item.title && (
                        <>
                          <TextSC fontWeight='bold'>{item.title}</TextSC>

                          <Spacing spacing='xxsmall' />
                        </>
                      )}

                      <TextSC>{item.text}</TextSC>
                    </ListItem>
                  ))}
              </List>
            </GridCol>
          </Grid>
        )}

        {button && (
          <>
            <Spacing spacing='xlarge' />

            <ButtonRegEvent color={button.color} />
          </>
        )}
      </Block>
    )
  }

  return (
    <Block>
      <Spacing spacing='uxlarge' />

      {title && <Heading h2={title} />}

      {items && items.length > 0 && (
        <>
          <Spacing spacing='large' />

          <List>
            {items.map((el, key) => (
              <ListItem
                key={key}
                alignItems='flex-start'
                StartIcon={<Image src={el.icon} style={{ marginTop: '-2px' }} />}
              >
                {el.title && (
                  <>
                    <TextSC fontWeight='bold'>{el.title}</TextSC>

                    <Spacing spacing='xxsmall' />
                  </>
                )}

                <TextSC>{el.text}</TextSC>
              </ListItem>
            ))}
          </List>
        </>
      )}

      {button && (
        <>
          <Spacing spacing='xlarge' />

          <ButtonRegEvent color={button.color} />
        </>
      )}
    </Block>
  )
}

export default memo(BlockWithList)
